export const lang = document.querySelector('html').lang;

// The locale __() currently translates into. Defaults to the page locale; a page that
// needs in-place language switching (the subscription cart) flips it with setLang() and
// re-renders. Everywhere else this never changes, so behaviour is unchanged.
let activeLocale = lang || 'en';

// The page's own single-locale table (legacy shape: window.__msiaTranslations).
const pageTable = window.__msiaTranslations || {};

// Resolve the lookup table for a locale. Pages that support switching inject a per-locale
// map (window.__msiaTranslationsByLocale, keyed by locale code); when that is absent — every
// page except the cart — we fall back to the page's own table, so nothing else is affected.
function tableFor(locale) {
    const byLocale = window.__msiaTranslationsByLocale;
    if (byLocale && byLocale[locale]) {
        return byLocale[locale];
    }
    return pageTable;
}

// Switch the locale __() translates into. In-place: the caller must trigger a re-render.
export function setLang(locale) {
    activeLocale = locale || 'en';
}

export function __(text) {
    const table = tableFor(activeLocale);
    return Object.prototype.hasOwnProperty.call(table, text) ? table[text] : text;
}
